module.exports = __webpack_public_path__ + "img/icon-core2-1.4c98a7de.png";